import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllProfessionsTable from './Table';
import AdminPageHead from '../../Common/PageHead';
import NewProfessionModal from '../../Modals/Profession/NewProfessionModal';
import style from './styles/style.module.css';

class AllProfessionsView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            professions: [],
            professionQueryObject: {
                sort: 'professions.title,professions.id',
            },
            newModal: false,
        };
    }
    componentDidMount() {
        this.loadProfessions();
    }
    onColumnSort = ( value ) => {
        if( this.state.professionQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.professions = [];
            prevState.professionQueryObject.page = 1;
            prevState.professionQueryObject.sort = value || undefined;
            return prevState;
        } );
        this.loadProfessions();
    }
    onSearch = ( value ) => {
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.professions = [];
            prevState.professionQueryObject.page = 1;
            prevState.professionQueryObject.search = value || undefined;
            return prevState;
        } );
        this.loadProfessions();
    }
    loadProfessions = () => {
        return this.props.getProfessions( this.state.professionQueryObject )
        .then( ( professions ) => {
            this.setState( ( prevState ) => {
                prevState.fetching= false,
                prevState.professions = prevState.professions.concat( professions ),
                prevState.professionQueryObject.page++;
                return prevState;
            } );
            return professions;
        } );
    }
    professionUpdated = ( index, profession ) => {
        this.setState( ( altState ) => {
            if( profession !== null ) {
                altState.professions[ index ] = profession;
                altState.professions = altState.professions.slice( 0 );
            } else {
                altState.professions = altState.professions.slice( 0, index ).concat( altState.professions.slice( index +1 ) );
            }
            return altState;
        } );
    }
    openNewModal = () => {
        this.setState( { newModal: true } );
    }
    onNewModalClose = () => {
        this.setState( { newModal: false } );
    }
    onNewModalSubmit = ( newProfession ) => {
        this.setState( ( altState ) => {
            altState.professions.unshift( newProfession );
            altState.professions = altState.professions.slice( 0 );
            altState.newModal = false;
            return altState;
        } );
    }

    render() {
        const { fetching, professions } = this.state;

        return (
            <section className={ style.page }>
                <AdminPageHead title='Professions'
                onSearch={ this.onSearch }
                tabs={ [
                    { label: 'View All', to: '/admin/professions' },
                ] }
                buttons={ [
                    { label: '+ Add New Profession', onClick: this.openNewModal },
                ] } />
                <div className={ style.body }>
                    <section className={ style.allList }>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllProfessionsTable
                            professions={ professions }
                            onColumnSort={ this.onColumnSort }
                            currentSort={ this.state.professionQueryObject.sort }
                            onProfessionUpdated={ this.professionUpdated }
                            elementHeight={ 70 } />
                        }
                    </section>
                </div>
                { this.state.newModal &&
                    <NewProfessionModal closeModal={ this.onNewModalClose }
                    onSubmit={ this.onNewModalSubmit } />
                }
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getProfessions: ( queryObject ) => {
            return dAPI.get( '/professions', queryObject );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllProfessionsView );
